import React from "react";

// Caps Lock 상태를 document 레벨에서 감지한다 — 대상 필드에 포커스가 오기 전
// (이메일 입력 중, 탭 이동 중)에 이미 상태를 알고 있어야
// 비밀번호 첫 글자를 치기 전에 경고를 띄울 수 있다.
export const useCapsLock = (enabled = true) => {
  const [capsLockOn, setCapsLockOn] = React.useState(false);

  React.useEffect(() => {
    if (!enabled) return;

    // 키보드 이벤트만 상태의 근거로 삼는다. 모든 브라우저가 Caps Lock을 실어 보낸다.
    const updateFromKey = (e: KeyboardEvent) =>
      setCapsLockOn(e.getModifierState("CapsLock"));

    // 마우스 이벤트의 Caps Lock은 브라우저마다 채워주기도, 항상 false로 오기도 한다.
    // true일 때만 신뢰해 경고를 켜고, false는 "모름"으로 보고 무시한다.
    // 그대로 반영하면 키보드로 켠 경고를 클릭 한 번에 지워버린다.
    const updateFromMouse = (e: MouseEvent) => {
      if (e.getModifierState("CapsLock")) setCapsLockOn(true);
    };

    // 창 밖에서 Caps Lock을 토글하면 페이지에 이벤트가 오지 않는다. 알 수 없는 상태를
    // 켜짐으로 남겨두면 틀린 경고가 유지되므로, 창을 벗어나는 순간 지우고
    // 돌아온 뒤 첫 입력에서 다시 판정한다.
    const clear = () => setCapsLockOn(false);

    document.addEventListener("keydown", updateFromKey);
    document.addEventListener("keyup", updateFromKey);
    document.addEventListener("mousedown", updateFromMouse);
    window.addEventListener("blur", clear);
    return () => {
      document.removeEventListener("keydown", updateFromKey);
      document.removeEventListener("keyup", updateFromKey);
      document.removeEventListener("mousedown", updateFromMouse);
      window.removeEventListener("blur", clear);
    };
  }, [enabled]);

  return capsLockOn;
};
